// Tooltip formatter for the scatter chart. Each point in the chart
// carries `value: [x, y]` plus `name` (group name) and `groupId`.
// Header is the group name, body has one row per axis with the axis
// label and the formatted value -- each axis uses its own
// `effectiveFormat` string so currency and return measures render in
// their natural units even when overlaid on the same chart.

export function escapeHtml (s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

/**
 * @param {(value: number, format?: string) => string} fmt -- formatting-context formatter
 * @param {object} opts
 * @param {string} opts.axisXLabel -- column header for the X measure
 * @param {string} opts.axisYLabel -- column header for the Y measure
 * @param {string} opts.axisXFormat -- numeral-style format string for X
 * @param {string} opts.axisYFormat -- numeral-style format string for Y
 */
export function buildScatterTooltipFormatter (fmt, { axisXLabel, axisYLabel, axisXFormat, axisYFormat }) {
  return function tooltipFormatter (params) {
    const point = params?.data || {}
    const v = Array.isArray(params?.value) ? params.value : Array.isArray(point.value) ? point.value : [null, null]
    const xVal = typeof v[0] === 'number' ? fmt(v[0], axisXFormat) : '--'
    const yVal = typeof v[1] === 'number' ? fmt(v[1], axisYFormat) : '--'
    const swatch = `<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${params?.color || 'currentColor'};flex-shrink:0;"></span>`

    return `
      <div style="display:flex;flex-direction:column;gap:4px;font-size:12px;min-width:160px;">
        <div style="display:flex;align-items:center;gap:6px;font-weight:600;">
          ${swatch}
          <span>${escapeHtml(point.name || params?.name || '')}</span>
        </div>
        <div style="display:flex;align-items:center;justify-content:space-between;gap:12px;">
          <span style="color:var(--color-neutral-500,#888);">${escapeHtml(axisXLabel || 'X')}</span>
          <span style="font-variant-numeric:tabular-nums;">${xVal}</span>
        </div>
        <div style="display:flex;align-items:center;justify-content:space-between;gap:12px;">
          <span style="color:var(--color-neutral-500,#888);">${escapeHtml(axisYLabel || 'Y')}</span>
          <span style="font-variant-numeric:tabular-nums;">${yVal}</span>
        </div>
      </div>
    `
  }
}
